import { Modal } from "@mui/material";
import ArrowBackIcon from "assets/icons/ArrowBackIcon";
import PlusIcon from "assets/icons/PlusIcon";
import BasicButton from "components/BasicInputs/BasicButton";
import ModalBox from "components/Shared/Modals/ModalBox";
import { UpdatePricesState } from "components/UpdatePrices";
import useUpdatePrice from "components/UpdatePrices/data";
import AddPlan from "components/UpdatePrices/modals/AddPlan";
import Change, { ChangePricesState } from "components/UpdatePrices/modals/Change";
import Plans from "components/UpdatePrices/modals/Plans";
import { useState } from "react";

type Props = {};

function PriceListSettings({}: Props) {
  const { table, pricePlans, addPlan, deletePlan, changePrices, savePrices } = useUpdatePrice();
  const [state, setState] = useState<UpdatePricesState>({});

  function handleAddPlan(plan: Plan) {
    setState((x) => ({ ...x, submitAddPlan: false }));
    addPlan(plan).then(() => {
      setState((x) => ({ ...x, open: undefined }));
    });
  }

  function handleDeletePlan(item: any) {
    deletePlan(item);
  }

  function handleChange(state: ChangePricesState,fromSpeed?:boolean) {
    setState((x) => ({ ...x, submitChange: false, open: undefined }));
    changePrices(state,fromSpeed);
  }

  const modalPages = {
    plans: {
      title: "لیست قیمت ها",
      body: (
        <Plans
          onDelete={handleDeletePlan}
          onEdit={(item) => setState((x) => ({ ...x, open: "addPlan", plan: item }))}
          plans={pricePlans}
        />
      ),
      footer: (
        <div style={{ display: "flex", justifyContent: "flex-end", width: "100%" }}>
          <BasicButton
            variant="contained"
            onClick={() => setState((x) => ({ ...x, open: "addPlan", plan: undefined }))}
          >
            <PlusIcon color="#fff" scale={0.7} />
            <span>افزودن لیست قیمت</span>
          </BasicButton>
        </div>
      ),
    },
    addPlan: {
      title: state.plan ? "ویرایش لیست قیمت" : "افزودن لیست قیمت",
      body: <AddPlan onSubmit={handleAddPlan} plan={state.plan} submit={state.submitAddPlan} />,
      footer: (
        <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
          <BasicButton
            style={{ color: "#7D96B8", borderColor: "#7D96B8" }}
            variant="outlined"
            onClick={() => setState((x) => ({ ...x, open: undefined }))}
          >
            <ArrowBackIcon color="#7D96B8" />
            <span>بازگشت</span>
          </BasicButton>
          <BasicButton variant="contained" onClick={() => setState((x) => ({ ...x, submitAddPlan: true }))}>
            {state.plan ? <span>ویرایش لیست</span> : <span>ایجاد لیست</span>}
          </BasicButton>
        </div>
      ),
    },
    change: {
      title: "تغییر قیمت سریع",
      body: <Change submit={state.submitChange} onsubmit={handleChange} plans={pricePlans} />,
      footer: (
        <BasicButton
          variant="contained"
          fullWidth
          onClick={() => setState((x) => ({ ...x, submitChange: true }))}
        >
          اعمال تغییرات
        </BasicButton>
      ),
    },
  };

  const modalPage = state.open && modalPages[state.open];
  return (
    <div>
      <div className="flex flex-row items-center w-full h-10 mb-11 ">
        <span className="ml-1 text-[#5B5B5C] text-xl font-medium">تنظیمات </span>
        <span className="text-[#5B5B5C] text-xl font-medium ">لیست قیمت ها</span>
        <div className="flex flex-1 justify-end">
          <BasicButton
            variant="contained"
            onClick={() => setState((x) => ({ ...x, open: "addPlan", plan: undefined }))}
          >
            <span>افزودن</span>
          </BasicButton>
        </div>
      </div>
      <Plans
        onDelete={handleDeletePlan}
        onEdit={(item) => setState((x) => ({ ...x, open: "addPlan", plan: item }))}
        plans={pricePlans}
      />
      <Modal open={Boolean(state.open)}>
        {modalPage ? (
          <ModalBox
            title={modalPage.title || ""}
            onClose={() => setState((x) => ({ ...x, open: undefined }))}
            style={{ container: { width: 425 } }}
            footer={modalPage.footer}
          >
            {modalPage.body}
          </ModalBox>
        ) : (
          <></>
        )}
      </Modal>
    </div>
  );
}

export default PriceListSettings;
